import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";
import { map, get } from "lodash";
import images from "../../assets/img/images";
import colors from "../../assets/style/colors";

const styles = {
    treeDiv: {
        marginLeft: 32,
        marginTop: 10,
        cursor: "pointer",
    },
    siteDiv: {
        marginLeft: 64,
        marginTop: 10,
        cursor: "pointer",
    },
    zoneCellSelected: {
        backgroundColor: colors.lightGreenBg + " !important",
        cursor: "pointer",
        marginBottom: 10,
        width: 250,
        padding: 5
    },
    zoneDiv: {
        cursor: "pointer",
        marginBottom: 10,
        padding: 5
    }
};

const SingleTree = withStyles(styles)((props) => {
    const {
        classes,
        tree,
        setZoneSelected,
        zoneSelected
    } = props;
    const [expandedZones, setExpandedZones] = React.useState(new Set());
    const [rootName, setRootName] = React.useState(tree["name"]);
    const [rootExpanded, setRootExpanded] = React.useState(false);



    return (
        <div>
            <div className={classes.treeDiv} onClick={() => setRootExpanded(!rootExpanded)}>
                <img
                    src={rootExpanded ? images.arrowOpenBlack : images.arrowClosedBlack}
                    height="14px"
                    style={{ maxWidth: "14px", marginRight: 5 }}
                    alt="arrow"
                />
                <span>{rootName}</span>
            </div>
            <div>
                {
                    rootExpanded ?
                        <div className={classes.siteDiv}>
                            {map(tree["sites"], (site) => (
                                <div key={site.id}>
                                    <img
                                        id={site["id"]}
                                        src={expandedZones.has(site["id"]) ? images.arrowOpenBlack : images.arrowClosedBlack}
                                        height="14px"
                                        style={{ maxWidth: "14px", marginRight: 5 }}
                                        alt="arrow"
                                        onClick={() => {
                                            if (expandedZones.has(site["id"])) {
                                                expandedZones.delete(site["id"])
                                            } else {
                                                expandedZones.add(site["id"])
                                            }
                                        }}
                                    />
                                    <span onClick={() => {
                                        if (expandedZones.has(site["id"])) {
                                            expandedZones.delete(site["id"])
                                        } else {
                                            expandedZones.add(site["id"])
                                        }
                                    }}>{site["name"]}</span>
                                    {
                                        expandedZones.has(site["id"]) ?
                                            <div className={classes.treeDiv}>
                                                {map(site["zones"], (zone) => (
                                                    <div key={zone.id} className={zoneSelected == zone["id"] ? classes.zoneCellSelected : classes.zoneDiv} onClick={() => { setZoneSelected(zone["id"]) }}>
                                                        <span>{zone["name"]}</span>
                                                    </div>
                                                ))}
                                            </div> :

                                            <></>
                                    }

                                </div>
                            ))}
                        </div>
                        :
                        <></>
                }
            </div>
        </div>
    );

});

const mapStateToProps = (state) => {
    return {
        language: get(state, ["user", "language"]),
    };
};

export default withRouter(SingleTree);
